import { NgModule } from '@angular/core';

import { ProductItemBaseComponent } from './product-item-base.component';

/**
 * Angular module providing the base product item component for financial products.
 *
 * @remarks
 * This module exports {@link ProductItemBaseComponent}, which serves as the foundation for all
 * product item components in the design system, such as bank accounts, credit cards, loans,
 * and investment products. It provides the base component that other product item modules
 * can extend from to ensure consistent behavior and API.
 *
 * @example
 *
 * ```typescript
 * import { ProductItemBaseModule } from '@backbase/ui-ang/base-classes';
 *
 * @NgModule({
 *   imports: [InputBaseModule, ProductItemBaseModule],
 *   exports: [InputBaseModule, ProductItemBaseModule],
 * })
 * export class BaseClassesModule {}
 * ```
 */
@NgModule({
  declarations: [ProductItemBaseComponent],
  exports: [ProductItemBaseComponent],
})
export class ProductItemBaseModule {}
